export default "__VITE_ASSET__CytThneX__"